import { render, staticRenderFns } from "./CollapseList.vue?vue&type=template&id=021d2814&scoped=true"
import script from "./CollapseList.vue?vue&type=script&lang=js"
export * from "./CollapseList.vue?vue&type=script&lang=js"
import style0 from "./CollapseList.vue?vue&type=style&index=0&id=021d2814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d2814",
  null
  
)

export default component.exports